import React, { useRef, createContext } from "react";

export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const tickerPalette = useRef({});
  const layoutRefs = useRef({
    filterCursor: {},
    filterStart: {},
  });
  const oar = useRef(null);
  const varx = useRef(null);

  const refs = { componentSize, tickerPalette, oar, varx, layoutRefs };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
